import type { Locale } from "@/i18n/config";
import type { Dictionary } from "./types";
import en from "./en";
import ru from "./ru";
import zh from "./zh";

export const dictionaries: Record<Locale, Dictionary> = { en, ru, zh };

export function getDictionary(locale: Locale): Dictionary {
  return dictionaries[locale];
}

export type { Dictionary };
